import { Environment } from '../../environment/environment';
import { TvshopConstants } from '../../tvshop-constants';
import { OmapiIdConstants } from '../../omapi-id-constants';
import { LabelConstants } from '../../label-constants';
import { ImageUtils } from '../image/image-utils';
import { OmapiIdsUtils } from '../omapi-ids/omapi-ids-utils';
var TrialUtils = /** @class */ (function () {
    function TrialUtils() {
    }
    TrialUtils.getTrialOmapiIdForTrialLabel = function (label) {
        return LabelConstants.LABEL_TRIAL_MAP.get(label);
    };
    TrialUtils.getLogoUrlForTrialOmapiId = function (trialOmapiId) {
        return trialOmapiId ? Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH +
            OmapiIdsUtils.getCorrectIdForResource(TrialUtils.getPackOmapiIdForTrial(trialOmapiId)) + '-logo.png' : '';
    };
    TrialUtils.getLogoUrlForOmapiId = function (omapiId) {
        return ImageUtils.getLogoUrlForOmapiId(omapiId);
    };
    TrialUtils.getPackOmapiIdForTrial = function (trialOmapiId) {
        return OmapiIdConstants.PRODUCT_TRIAL_MAP.get(trialOmapiId);
    };
    return TrialUtils;
}());
export { TrialUtils };
